module.exports = __webpack_public_path__ + "static/media/bmo.35ee062a.jpg";